<template>
  <div class="testResultBox pa-0 ma-0">
    <p class="body1 mt-4 mb-4">
      {{ question }}
    </p>

    <div class="my-4">
      <span class="pa-1 body-1" :class="answer ? 'greenBox' : 'redBox'">
        {{ answer ? $t("tests.functional.yes") : $t("tests.functional.no") }}
      </span>
    </div>

    <h4>{{ $t("evaluation.result.comment") }}</h4>
    <span class="body-1 text-grey-darker">{{ comment }}</span>
  </div>
</template>
<script>
export default {
  name: "yes-no-answer-box",
  props: ["question", "answer", "comment"],
};
</script>
